const checkTrainDepartDate = (trainId: string) => {
    // Extract the day part from the train ID
    let dayPart;

    // Handle train IDs with dashes (e.g., Z12345-07)
    if (trainId.includes('-')) {
        // If the train ID contains a dash, take the part after the dash
        dayPart = trainId.split('-')[1];
    } else {
        // Otherwise, take the last two characters
        dayPart = trainId.slice(-2);
    }

    // Parse the day part as an integer
    const trainDepartDay = parseInt(dayPart, 10);

    // Get the current date
    const currentDate = new Date();
    const currentDateNumber = currentDate.getDate();
    const currentMonth = currentDate.getMonth();
    const currentYear = currentDate.getFullYear();

    // Create a new date object for the origin departure date
    let originDepartureDate;

    if (trainDepartDay <= currentDateNumber) {
        // Current month
        originDepartureDate = new Date(currentYear, currentMonth, trainDepartDay);
    } else {
        // Try to set the date in the previous month
        const previousMonth = currentMonth - 1;
        const previousMonthYear = previousMonth < 0 ? currentYear - 1 : currentYear;
        const adjustedMonth = previousMonth < 0 ? 11 : previousMonth;

        // Create a test date to see if this day exists in the previous month
        const testDate = new Date(previousMonthYear, adjustedMonth, trainDepartDay);

        // Check if the day rolled over to the next month (which means the day doesn't exist in previous month)
        if (testDate.getMonth() !== adjustedMonth) {
            // If the day doesn't exist in the previous month, use the current month instead
            originDepartureDate = new Date(currentYear, currentMonth, trainDepartDay);
        } else {
            // The day exists in the previous month, use it
            originDepartureDate = testDate;
        }
    }

    return originDepartureDate;
}

export default checkTrainDepartDate;